<app-simple-toast-group [messages]="messages$ | async" (dismiss)="onMessageDismiss($event)">
</app-simple-toast-group>
